module.exports = __webpack_public_path__ + "b765ec173cdc9fff4751fc42491aaa95.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/turn_on.png
// module id = 2870
// module chunks = 0